import script from "./KioskHome.vue?vue&type=script&setup=true&lang=js"
export * from "./KioskHome.vue?vue&type=script&setup=true&lang=js"

import "./KioskHome.vue?vue&type=style&index=0&id=554a5db4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554a5db4"]])

export default __exports__